import script from "./NewMyProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./NewMyProfile.vue?vue&type=script&setup=true&lang=js"

import "./NewMyProfile.vue?vue&type=style&index=0&id=36871380&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36871380"]])

export default __exports__